import React from 'react';
import LoginScreen from '@/components/auth/LoginScreen';

const GUIDE_BG = 'https://images.pexels.com/photos/17983542/pexels-photo-17983542.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1200';

export default function GuideLogin() {
  return (
    <LoginScreen
      bg={GUIDE_BG}
      badge="Accesso Guide"
      heroTitle="Racconta la Sila ai viaggiatori."
      heroText="Gestisci il tuo profilo e i tuoi itinerari nella rete Sila Experiences: prenotazioni, mappa 3D e vetrina pubblica."
      formTitle="Bentornata/o, Guida"
      formSubtitle="Accedi al tuo CRM Guida del Parco."
      register={{ prefix: 'Non sei ancora una guida?', to: '/guida/registrati', label: 'Candidati come Guida' }}
      testidPrefix="guide-login"
    />
  );
}
